module.exports = __webpack_public_path__ + "de549f256c671a6c60ecefc62b900925.png";